<template>
  <form
    class="my-10 mx-4 md:mx-15 xl:mx-0"
    @submit.prevent="sendForm"
  >
    <!-- --------------- BEGIN Page Contact --------------- -->
    <h2 class="text-3xl text-gray-900 mt-20 mb-10 font-normal">
      Contact
    </h2>

    <div class="text-center">
      <p
        v-if="$subscribed()"
        class="mb-10 text-lg text-indigo-600"
      >
        Pour obtenir de l’aide, vous pouvez nous contacter par téléphone :
      </p>
      <a
        v-if="$subscribed()"
        :href="hrefTel"
        class="text-pink-600 text-3xl"
      >{{ tel }}</a>
      <p
        v-if="$subscribed()"
        class="mt-10 text-lg text-indigo-600"
      >
        Ou via le formulaire de contact ci-dessous.
      </p>
      <p
        v-else
        class="mb-10 text-lg text-indigo-600"
      >
        Pour obtenir de l’aide, vous pouvez nous contacter  via le formulaire de contact ci-dessous.
      </p>
    </div>

    <div class="my-10 w-full">
      <div class="grid grid-cols-12 gap-x-4 gap-y-5 xl:mx-1/5 2xl:mx-1/4">
        <input-text
          class="md:col-span-6"
          required="required"
          name="firstname"
          libelle="Prénom"
          :value="form.firstname"
          @input="
            (newValue) => {
              form.firstname = newValue;
            }
          "
          :error="true"
          :msg-error="(errors.firstname || [])[0] || ''"
          @focusInput="(errors.firstname || [])[0] = ''"
        />
        <input-text
          class="md:col-span-6"
          required="required"
          name="lastname"
          libelle="Nom"
          :value="form.lastname"
          @input="
            (newValue) => {
              form.lastname = newValue;
            }
          "
          :error="true"
          :msg-error="(errors.lastname || [])[0] || ''"
          @focusInput="(errors.lastname || [])[0] = ''"
        />
        <input-text
          v-if="!$freeParticulier()"
          class="md:col-span-6"
          required="required"
          name="company"
          libelle="Entreprise"
          :disabled="true"
          :value="form.company"
          @input="
            (newValue) => {
              form.company = newValue;
            }
          "
          :error="true"
          :msg-error="(errors.company || [])[0] || ''"
          @focusInput="(errors.company || [])[0] = ''"
        />

        <input-text
          class="md:col-span-6"
          required="required"
          name="email"
          type="email"
          libelle="Email"
          :value="form.email"
          @input="
            (newValue) => {
              form.email = newValue;
            }
          "
          :error="true"
          :msg-error="errors.email || ''"
          @focusInput="errors.email = ''"
        />
        <input-text
          v-if="$subscribed()"
          class="md:col-span-6"
          required="required"
          name="phone_number"
          type="tel"
          libelle="Téléphone"
          :value="form.phone_number"
          @input="
            (newValue) => {
              form.phone_number = newValue;
            }
          "
          :error="true"
          :msg-error="errors.phone_number"
          @focusInput="errors.phone_number = ''"
        />
        <input-select
          name="role"
          class="md:col-span-6"
          libelle="Type de demande"
          :datas="listeTypesDemande"
          :value="form.typeDemande"
          @input="
            (newValue) => {
              form.typeDemande = newValue;
            }
          "
          :required="true"
          :error="true"
          :msg-error="(errors.typeDemande || [])[0] || ''"
          @focusInput="(errors.typeDemande || [])[0] = ''"
        />
        <input-text-area
          class="md:col-span-full"
          size="5"
          name="message"
          libelle="Message"
          :value="form.message"
          @input="
            (newValue) => {
              form.message = newValue;
            }
          "
          :required="true"
          :error="true"
          :msg-error="(errors.message || [])[0] || ''"
          @focusInput="(errors.message || [])[0] = ''"
        />

        <div class="flex justify-center lg:justify-end col-span-full">
          <action-button
            class="mt-10"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-pink-600"
            bg-color-square="bg-pink-600"
            icon-color="text-white"
            libelle="Envoyer"
            :uppercase="true"
            icon="plane"
            type-shadow="shadow-pink"
            :right="true"
            :spinner="sending"
            @clickAction="sendForm"
          />
        </div>
      </div>
    </div>
    <!-- --------------- END Page Contact --------------- -->
  </form>
</template>

<script>
import axios from './../../api';
import store from './../../store';
import ActionButton from './../../components/ActionButton';
import InputText from './../../components/Inputs/InputText';
import InputTextArea from './../../components/Inputs/InputTextArea';
import InputSelect from './../../components/Inputs/InputSelect';
import {mapGetters} from 'vuex';

export default {
  name: 'Contact',

  components: {
    ActionButton,
    InputText,
    InputTextArea,
    InputSelect,
  },

  data() {
    return {
      tel: '06 33 01 76 16',
      sending: false,
      form: {
        username: '',
        firstname: '',
        lastname: '',
        email: '',
        phone_number: '',
        company: '',
        function: '',
        typeDemande: '',
        message: '',
      },
      listeTypesDemande: [
        { value: 'Conseil technique' },
        { value: 'Facturation et commande' },
        { value: 'Incident' },
      ],
      errors: {
        phone_number: '',
        email: '',
      },
    };
  },

  computed: {
    hrefTel() {
      return `tel:${this.tel}`;
    },

    ...mapGetters({
      user: 'auth/user'
    })
  },

  created() {
    this.$store.commit('help/SET_MESSAGEHEADER', null);
    this.initForm();
  },

  methods: {
    async sendForm() {
      if (this.$subscribed() && (!this.form.phone_number || this.form.phone_number === '')) {
        this.errors.phone_number = 'Veuillez renseigner un numéro de téléphone';
        return;
      }


      if (this.$subscribed() &&
       ( !/^\d+$/.test(this.form.phone_number.replaceAll(/\s/g, '')) ||
        this.form.phone_number.replaceAll(/\s/g, '').length != 10)
      ) {
        this.errors.phone_number =
          'Le numéro de téléphone n\'est pas au bon format';
        return;
      } else if (
        !/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          this.form.email
        )
      ) {
        this.errors.email = 'L\'adresse mail n\'est pas au bon format';
        return;
      }
      this.sending = true;
      this.$store.commit('help/SET_MESSAGEHEADER', null);

      try {
        const { data } = await axios.post('/api/contact/send', this.form);

        if (data.sent) {
          this.initForm();
          this.$store.commit('help/SET_MESSAGEHEADER', {
            type: 'success',
            msg: 'Votre message a bien été envoyé. Un membre de l\'équipe Neopass vous répondra dans les meilleurs délais.',
          });
          setTimeout(() => {
            this.$store.commit('help/SET_MESSAGEHEADER', null);
          }, 3000);
        }
      } catch (err) {
        const error = err.response ? err.response.data : err;

        this.errors = { ...this.errors, ...error.errors };

        this.$store.commit('help/SET_MESSAGEHEADER', {
          type: 'error',
          msg: 'Impossible d\'envoyer le message. Veuillez réessayer',
        });
        setTimeout(() => {
          this.$store.commit('help/SET_MESSAGEHEADER', null);
        }, 3000);
      } finally {
        this.sending = false;
      }
    },

    initForm() {
      const user = store.getters['auth/user'];
      this.form.message = '';
      this.form.username = user.username;
      this.form.firstname = user.firstname;
      this.form.lastname = user.lastname;
      this.form.email = user.email;
      this.form.phone_number = user.phone_number ?? '';
      this.form.typeDemande = '';

      //Particulier user hasn't company
      if (this.$freeParticulier()) {
        return;
      }

      axios.get('/api/users/company/' + user.id).then((response) => {
        this.form.company = response.data.name;
      });
    },
  },
};
</script>
